export default function baseUrl() {
    //return 'http://0.0.0.0:8000/api/v1/'
    //return 'http://217.76.53.96:8000/api/v1/'
    //return 'http://154.118.227.140:8002/api/v1/'
    // 'http://nluis.nlupc.go.tz:8002/api/v1'
    //return 'http://172.16.100.15:8000/api/v1/'
    if(process.env.NODE_ENV === 'development'){
        return process.env.REACT_APP_TEST_API_URL  
    }
    else{
        return process.env.REACT_APP_API_URL
    }
}
